// Define interfaces for the data structure
interface Event {
	id: number
	slug: string
	enabled: boolean
	title: string
	description: string
	startsAt: string
	endsAt: string
	claimingEnabledAt: string | null
	isClaimingEnabled: boolean
	latestPaymentDueDateOffset: number | null
	sealedTicketingUrl: string
}

interface EventState {
	events: Event[]
}

function convertJsonToEvent(json: any): Event {
	return {
		id: json.id,
		slug: json.slug,
		enabled: json.enabled,
		title: json.title,
		description: json.description,
		startsAt: json.starts_at,
		endsAt: json.ends_at,
		claimingEnabledAt: json.claiming_enabled_at ?? null,
		isClaimingEnabled: Boolean(json.is_claiming_enabled),
		latestPaymentDueDateOffset: -1,
		sealedTicketingUrl: json.sealed_ticketing_url,
	}
}

// Define the Pinia store
export const useEventStore = defineStore("eventStore", {
	state: (): EventState => ({
		events: [],
	}),

	getters: {
		getEventById: (state: EventState) => (id: number) => {
			return state.events.find((event: any) => event.id === id)
		},
		// isEventActive: (state: EventState) => {
		// 	if (!state.event) return false
		// 	const now = new Date()
		// 	const startDate = new Date(state.event.startsAt)
		// 	const endDate = new Date(state.event.endsAt)
		// 	return now >= startDate && now <= endDate
		// },
		getAllEvents: (state: EventState) => () => {
			return state.events
		},
		getFutureEvents: (state: EventState) => () => {
			const now = new Date()
			let allEvents = state.events.filter((event: Event) => now <= new Date(event.endsAt))
			return allEvents.sort((a: Event, b: Event) => {
				//Sort the events by EndsAt, ascending order
				if (a.endsAt < b.endsAt) return -1
				if (a.endsAt > b.endsAt) return 1
				return 0
			})
		},
		getPastEvents: (state: EventState) => () => {
			const now = new Date()
			let allEvents = state.events.filter((event: Event) => now > new Date(event.endsAt))
			return allEvents.sort((a: Event, b: Event) => {
				//Sort the events by endsAt, descending order
				if (a.endsAt > b.endsAt) return -1
				if (a.endsAt < b.endsAt) return 1
				return 0
			})
		},
	},

	actions: {
		storeEventsFromJson(events: any) {
			events.forEach((event: any) => {
				// @ts-ignore
				this.events.push(convertJsonToEvent(event))
			})
		},
		clear() {
			// @ts-ignore
			this.events = []
		},
	},

	persist: {
		key: "up_eventStore", // Make sure this key is unique
		storage: localStorage, // or cookies if you're using cookie storage
	},
})
